import { TYPE_BOOLEAN } from './input-types';

export const id = 'isRefund';
export const apiKey = 'IsRefund';
export const type = TYPE_BOOLEAN;

export const isRefund = {
  id,
  apiKey,
  type,
};
